module.exports = __webpack_public_path__ + "media/images/classifieds-c8eb20fb39ce79ed2789d6497dc431fa.png";